/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmBootstrapFieldMismatchEntryDto
 */
export interface MdmBootstrapFieldMismatchEntryDto {
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    configurationId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    configurationName?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    sourceKind?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    assetClass?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    ruleIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    ruleName?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    legacyFieldName?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchEntryDto
     */
    canonicalFieldName?: string;
}

/**
 * Check if a given object implements the MdmBootstrapFieldMismatchEntryDto interface.
 */
export function instanceOfMdmBootstrapFieldMismatchEntryDto(value: object): value is MdmBootstrapFieldMismatchEntryDto {
    return true;
}

export function MdmBootstrapFieldMismatchEntryDtoFromJSON(json: any): MdmBootstrapFieldMismatchEntryDto {
    return MdmBootstrapFieldMismatchEntryDtoFromJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmBootstrapFieldMismatchEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'configurationId': json['configurationId'] == null ? undefined : json['configurationId'],
        'configurationName': json['configurationName'] == null ? undefined : json['configurationName'],
        'sourceKind': json['sourceKind'] == null ? undefined : json['sourceKind'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'ruleIndex': json['ruleIndex'] == null ? undefined : json['ruleIndex'],
        'ruleName': json['ruleName'] == null ? undefined : json['ruleName'],
        'legacyFieldName': json['legacyFieldName'] == null ? undefined : json['legacyFieldName'],
        'canonicalFieldName': json['canonicalFieldName'] == null ? undefined : json['canonicalFieldName'],
    };
}

export function MdmBootstrapFieldMismatchEntryDtoToJSON(json: any): MdmBootstrapFieldMismatchEntryDto {
    return MdmBootstrapFieldMismatchEntryDtoToJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchEntryDtoToJSONTyped(value?: MdmBootstrapFieldMismatchEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configurationId': value['configurationId'],
        'configurationName': value['configurationName'],
        'sourceKind': value['sourceKind'],
        'entityType': value['entityType'],
        'assetClass': value['assetClass'],
        'ruleIndex': value['ruleIndex'],
        'ruleName': value['ruleName'],
        'legacyFieldName': value['legacyFieldName'],
        'canonicalFieldName': value['canonicalFieldName'],
    };
}

